import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Declare global __DEV__ variable
declare global {
  const __DEV__: boolean;
}

// Add global error handler for better debugging
window.addEventListener('error', (event) => {
  console.error('Global error caught:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack
  });
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', {
    reason: event.reason,
    promise: event.promise
  });
});

// Add better error logging for production
if (!__DEV__) {
  console.log('Running in production mode');

  // Override console.error to capture more details
  const originalError = console.error;
  console.error = (...args) => {
    originalError.apply(console, args);

    // Log additional context
    if (args[0] && typeof args[0] === 'string' && args[0].includes('undefined is not a function')) {
      console.error('Additional context for undefined function error:', {
        stack: new Error().stack,
        userAgent: navigator.userAgent,
        url: window.location.href,
        timestamp: new Date().toISOString()
      });
    }
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Wrap the render in a try-catch for better error handling
try {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('Error during React render:', error);
  // Fallback render
  root.render(
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Something went wrong</h1>
      <p>Please refresh the page or contact support.</p>
      {__DEV__ && (
        <details>
          <summary>Error Details (Development Only)</summary>
          <pre>{error instanceof Error ? error.stack : String(error)}</pre>
        </details>
      )}
    </div>
  );
}

reportWebVitals();

// Service worker registration is now handled by the useServiceWorker hook in the app components
